module.exports = __webpack_public_path__ + "static/media/preview.2de97a75.png";